/* istanbul ignore next */
const ACTIONS = {
    VERIFY_PM_ELIGIBILITY: 'VERIFY_PM_ELIGIBILITY',
    UPDATE_ONBOARDING_STATUS_TO_BMX_IDENTIFIED: 'UPDATE_ONBOARDING_STATUS_TO_BMX_IDENTIFIED',
    CONFIRMATION_SERVICE_ERROR: 'CONFIRMATION_SERVICE_ERROR',
    SET_BUSINESS_MODEL_SWITCH_CHOICE: 'SET_BUSINESS_MODEL_SWITCH_CHOICE'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    updateOnboardingStatus() {
        return {
            type: ACTIONS.VERIFY_PM_ELIGIBILITY,
        };
    },

    updateOnboardingStatusToBMXIdentified() {
        return {
            type: ACTIONS.UPDATE_ONBOARDING_STATUS_TO_BMX_IDENTIFIED,
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.CONFIRMATION_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    setBusinessModelSwitchChoice(advertiserBusinessModel, preferredBusinessModel, currency, rowMorEnabled, rolloutStrategy) {
        return {
            type: ACTIONS.SET_BUSINESS_MODEL_SWITCH_CHOICE,
            payload: {
                advertiserBusinessModel,
                rolloutStrategy,
                preferredBusinessModel,
                currency,
                rowMorEnabled
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
